import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Cleano Management's dark-blue theme. Matches the CSS tokens used across
// the marketing pages and the staff/admin/customer portals.
export default new Vuetify({
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#5BB4E5',
        secondary: '#A6DBF7',
        accent: '#3A8CC2',
        info: '#5BB4E5',
        success: '#4FC1AE',
        warning: '#E0A93E',
        error: '#E57373',
        background: '#070A10',
        surface: '#0D121B',
      },
      light: {
        primary: '#3A8CC2',
        secondary: '#5BB4E5',
        accent: '#A6DBF7',
      },
    },
  },
});
